
import { NavigateFunction } from "react-router-dom";
import { HttpClient } from "./http-client";
import { IUserData } from "./models/user-data";
import { objectToFormData } from "./utils/object-to-form-data";

export const logIn = (httpClient: HttpClient, username: string, password: string) =>
{
    const fetchData = async () =>
    {
        let data = (await httpClient.post<IUserData[]>(
            "user/login", "",
            objectToFormData({
                username: username,
                password: password
            }), 15000)).data;


        if (data.token)
        {
            localStorage.setItem("user", JSON.stringify(data));
        }

        return data;
    };

    fetchData().catch(console.error);
};

const parseJwt = (token: string) =>
{
    try
    {
        return JSON.parse(atob(token.split(".")[1]));
    }
    catch (e)
    {
        return null;
    }
};
export const authVeryify = (navigate: NavigateFunction) =>
{
    let user = getCurrentUser();
    if (user)
    {
        const decodedJwt = parseJwt(user.token);
        if (decodedJwt.exp * 1000 < Date.now())
        {
            logOut(navigate);
        }
    }
};


export const logOut = (navigate: NavigateFunction) =>
{
    localStorage.removeItem("user");
    localStorage.clear();
    navigate("/login");
    window.location.reload();
};

export const getCurrentUser = () =>
{
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);

    return null;
};
